import { createUseStyles } from 'react-jss';
import { Spacings } from '@picsart/design-system/foundation/spacings';

const useStyles = createUseStyles<string, { isBannerBlockWidget?: boolean }>(
  {
    title: {
      width: '30%',
      height: 50,
      marginInline: 'auto',
    },

    description: {
      width: '50%',
      height: 28,
      marginInline: 'auto',
    },

    widget: {
      marginInline: 'auto',
      width: params => (params?.isBannerBlockWidget ? 'min(100%, 490px)' : 'min(100%, 712px)'),
      height: params => (params?.isBannerBlockWidget ? 320 : 250),
      marginBottom: Spacings.s4,

      '@media screen and (max-width: 500px)': {
        width: 327,
      },
    },

    rating: {
      width: 300,
      height: 120,
      marginBottom: Spacings.s8,
      marginInline: 'auto',
    },

    img: {
      marginInline: 'auto',
      height: 55,
      width: 454,
    },
  },
  {
    name: 'WidgetExperimentFallback',
  },
);

export default useStyles;
